import React from 'react';
import { motion } from 'framer-motion';
import { Plus, Filter, AlertCircle, Users } from 'lucide-react';
import { Link } from 'react-router-dom';
const columns = [{
  id: 'prospect',
  title: 'Prospect',
  count: 2,
  color: 'border'
}, {
  id: 'contacted',
  title: 'Contacted',
  count: 3,
  color: 'blue'
}, {
  id: 'replied',
  title: 'Replied',
  count: 2,
  color: 'purple'
}, {
  id: 'offer',
  title: 'Offer',
  count: 2,
  color: 'primary'
}, {
  id: 'hold',
  title: 'Hold',
  count: 1,
  color: 'amber'
}, {
  id: 'confirmed',
  title: 'Confirmed',
  count: 3,
  color: 'green'
}];
const deals = {
  prospect: [{
    venue: 'Schubas Tavern',
    date: 'Jun 11',
    value: 'TBD',
    assignee: 'M'
  }, {
    venue: 'Lincoln Hall',
    date: 'Jun 13',
    value: 'TBD',
    assignee: 'M'
  }],
  contacted: [{
    venue: 'The Ark',
    date: 'Jun 15',
    value: 'TBD',
    assignee: 'S'
  }, {
    venue: 'Iron Horse',
    date: 'Jun 20',
    value: 'TBD',
    assignee: 'M'
  }, {
    venue: 'Space',
    date: 'Jun 12',
    value: 'TBD',
    assignee: 'S'
  }],
  replied: [{
    venue: 'Club Passim',
    date: 'Jun 22',
    value: 'TBD',
    assignee: 'M',
    flags: ['policy']
  }, {
    venue: 'The Sinclair',
    date: 'Jun 21',
    value: 'TBD',
    assignee: 'M'
  }],
  offer: [{
    venue: 'The Empty Bottle',
    date: 'Jun 12',
    value: '$1,500',
    assignee: 'M',
    flags: ['policy']
  }, {
    venue: 'Higher Ground',
    date: 'Jun 18',
    value: '$2,200',
    assignee: 'S'
  }],
  hold: [{
    venue: 'Beachland Tavern',
    date: 'Jun 14',
    value: '$1,800',
    assignee: 'M',
    timer: '3 days left',
    flags: ['lineup']
  }],
  confirmed: [{
    venue: "Antone's",
    date: 'Mar 15',
    value: '$2,000',
    assignee: 'M'
  }, {
    venue: 'Continental Club',
    date: 'Mar 18',
    value: '$1,800',
    assignee: 'M'
  }, {
    venue: 'White Oak',
    date: 'Mar 20',
    value: '$2,500',
    assignee: 'S'
  }]
};
export function DealsPage() {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="h-[calc(100vh-8rem)] flex flex-col" data-id="element-3056">
      {/* Header */}
      <div className="flex justify-between items-center mb-6 shrink-0" data-id="element-3057">
        <div className="flex items-center gap-3" data-id="element-3058">
          <select className="px-3 py-2 bg-surface border border-border rounded-lg text-sm focus:outline-none focus:border-primary text-textMain font-medium" data-id="element-3059">
            <option data-id="element-3060">Summer Run '26</option>
            <option data-id="element-3061">All Active Deals</option>
          </select>
          <button className="p-2 bg-surface border border-border rounded-lg text-textMuted hover:text-textMain transition-colors" data-id="element-3062">
            <Filter className="w-4 h-4" data-id="element-3063" />
          </button>
        </div>
        <button className="px-4 py-2 bg-primary text-background rounded-lg hover:bg-primaryHover transition-colors font-medium flex items-center gap-2 text-sm shadow-[0_0_10px_rgba(245,158,11,0.2)]" data-id="element-3064">
          <Plus className="w-4 h-4" data-id="element-3065" />
          New Deal
        </button>
      </div>

      {/* Kanban Board */}
      <div className="flex-1 overflow-x-auto pb-4" data-id="element-3066">
        <div className="flex gap-4 h-full min-w-max px-1" data-id="element-3067">
          {columns.map(col => <div key={col.id} className="w-72 flex flex-col h-full" data-id="element-3068">
              {/* Column Header */}
              <div className="flex items-center justify-between mb-3 px-1" data-id="element-3069">
                <h3 className="text-sm font-semibold text-textMuted uppercase tracking-wider" data-id="element-3070">
                  {col.title}
                </h3>
                <span className="px-2 py-0.5 bg-surface border border-border rounded text-xs font-medium text-textMuted" data-id="element-3071">
                  {col.count}
                </span>
              </div>

              {/* Column Body */}
              <div className="flex-1 bg-surface/30 border border-border border-dashed rounded-xl p-2 overflow-y-auto space-y-3" data-id="element-3072">
                {deals[col.id as keyof typeof deals].map((deal, i) => <Link to={`/app/deals/${deal.venue.toLowerCase().replace(/\s+/g, '-')}`} key={i} className={`block bg-surface border border-border rounded-lg p-3 shadow-sm hover:border-${col.color}-500/50 transition-colors cursor-grab border-l-2 border-l-${col.color}-500`} data-id="element-3073">
                    <div className="flex justify-between items-start mb-2" data-id="element-3074">
                      <div className="font-medium text-sm" data-id="element-3075">{deal.venue}</div>
                      <div className="w-5 h-5 rounded-full bg-background border border-border flex items-center justify-center text-[10px] font-bold text-textMuted" data-id="element-3076">
                        {deal.assignee}
                      </div>
                    </div>

                    <div className="flex justify-between items-center text-xs text-textMuted mb-3" data-id="element-3077">
                      <span data-id="element-3078">{deal.date}</span>
                      <span className={deal.value !== 'TBD' ? 'text-textMain font-medium' : ''} data-id="element-3079">
                        {deal.value}
                      </span>
                    </div>

                    {/* Flags & Timers */}
                    {(deal.flags || deal.timer) && <div className="flex flex-wrap gap-2 pt-2 border-t border-border" data-id="element-3080">
                        {deal.timer && <span className="px-1.5 py-0.5 bg-amber-500/10 text-amber-500 text-[10px] rounded flex items-center gap-1" data-id="element-3081">
                            <Clock className="w-3 h-3" data-id="element-3082" /> {deal.timer}
                          </span>}
                        {deal.flags?.includes('policy') && <span className="px-1.5 py-0.5 bg-red-500/10 text-red-500 text-[10px] rounded flex items-center gap-1" title="Below target fee" data-id="element-3083">
                            <AlertCircle className="w-3 h-3" data-id="element-3084" /> Policy
                          </span>}
                        {deal.flags?.includes('lineup') && <span className="px-1.5 py-0.5 bg-blue-500/10 text-blue-500 text-[10px] rounded flex items-center gap-1" title="Lineup conflict" data-id="element-3085">
                            <Users className="w-3 h-3" data-id="element-3086" /> Lineup
                          </span>}
                      </div>}
                  </Link>)}
              </div>
            </div>)}
        </div>
      </div>
    </motion.div>;
}
// Need to import Clock since I used it in the DealsPage
import { Clock } from 'lucide-react';